import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import RisingalentBadge from '../assets/badges/risingTalent.png';
import TopRatedBadge from '../assets/badges/topRated.png';
import TopRatedPlusBadge from '../assets/badges/topRatedPlus.png';
import Verified from '../assets/badges/verified.png';

export const getBadgeIcon = (badgeName, size=30) => {
  const badgeIcon = 
    badgeName === "Verified"
      ? Verified
      : badgeName === "Rising Talent"
      ? RisingalentBadge
      : badgeName === "Top Rated"
      ? TopRatedBadge
      : badgeName === "Top Rated Plus"
      ? TopRatedPlusBadge
      : "";

  return (
    <OverlayTrigger
      placement="top" 
      overlay={
        <Tooltip id={`tooltip-${badgeName}`}>
          {badgeName}
        </Tooltip>
      }
    >
      <img
        src={badgeIcon}
        alt={badgeName}
        style={{ width: `${size}px`, height: `${size}px`, cursor: 'pointer' }} 
      />
    </OverlayTrigger>
  );
};
